import styled from '@emotion/styled'
import { Alert } from '@mui/material'

const AlertBox = styled(Alert)`
  max-width: 500px;
  width: 100%;
  margin: ${props => props.margin};
  border-radius: 4px;

  @media (max-width: 768px) {
    width: 90%;
  }
`

const AlertContainer = ({ severity, margin = 0, children }) => {
  return (
    <AlertBox severity={severity} margin={margin}>
      {children}
    </AlertBox>
  )
}
export default AlertContainer
